<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      Mastitis Control Measures
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <subsection
        :title="farm.farm_label"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-mastitis_control_measures`"
        v-for="farm in model.FARMS"
        :key="farm.id"
      >
        <dl class="dl-horizontal">
          <dt>Shed type</dt>
          <dd>{{ model[`farm_${farm.id}-shed_type`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Bales</dt>
          <dd>{{ model[`farm_${farm.id}-bales`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Cows milk out well?</dt>
          <dd>{{ model[`farm_${farm.id}-do_cows_milk_well`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Teat condition</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-mcm_teat_condition`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Teat spraying product used</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-mcm_teat_spraying_product_used`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Application</dt>
          <dd>{{ model[`farm_${farm.id}-teat_application`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Comments on concentration or application</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-mcm_comments_on_concentration_or_application`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Annual Machine check?</dt>
          <dd>{{ model[`farm_${farm.id}-does_annual_machine_check`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Scheduled rubber ware checks?</dt>
          <dd>{{ model[`farm_${farm.id}-does_rubber_checks`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>If YES, how often?</dt>
          <dd>{{ model[`farm_${farm.id}-rubber_checks_how_often`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Frequency liners are changed</dt>
          <dd>{{ model[`farm_${farm.id}-liner_change_frequency`] || '-' }}</dd>
        </dl>
      </subsection>

      <subsection
        :title="`Detection and Treatment of Clinical Cases - ${farm.farm_label}`"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-detection_and_treatment_of_clinical_cases`"
        v-for="farm in model.FARMS"
        :key="`farm_${farm.id}-detection_and_treatment_of_clinical_cases`"
      >
        <dl class="dl-horizontal">
          <dt>Whole herd regularly stripped for clinical cases?</dt>
          <dd>{{ model[`farm_${farm.id}-is_herd_stripped_clinical_cases`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Mastitis cows managed in a penicillin mob?</dt>
          <dd>{{ model[`farm_${farm.id}-mastitis_cows_in_penicillin_mob`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>If YES, milking frequency?</dt>
          <dd>{{ model[`farm_${farm.id}-mastitis_mob_milk_freq`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Teat wipes used when inserting intramammaries?</dt>
          <dd>{{ model[`farm_${farm.id}-are_teat_wipes_used`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Number of inhibitory substance grades</dt>
          <dd>{{ model[`farm_${farm.id}-num_inhibitory_substance_grades`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Number of near misses</dt>
          <dd>{{ model[`farm_${farm.id}-num_near_misses`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Comments</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-detection_and_treatment_of_clinical_cases`] || '-' }}</dd>
        </dl>
      </subsection>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'MastitisControlMeasures',
  mixins: [mixin],
  props: ['model'],
}
</script>
